import {defineStore} from "pinia"
import {AppContext} from "@hc/graphql"
import {ref, computed} from "vue"
import _ from 'lodash'

export const useConfigStore = defineStore('config', () => {
  const settings = ref<Record<string, any>>({})
  const app = ref<string>(null)
  const scope = ref<string>(null)
  const uiPath = ref<string>(null)
  const api = ref<AppContext>(null)
  const environment = process.env.NODE_ENV || 'development'
  const debug = ref(environment == 'development')

  function get(name: string, defaultValue?: any){
    const value = _.get(settings.value, name, defaultValue)
    return value
  }

  function serviceUrl(name: string, path: string = ''): string {
    const baseUrl = get('services.' + name)
    if(!baseUrl) throw new Error("Service '" + name + "' not found")
    const url =  baseUrl + (path.startsWith('/') ? '' : '/') +path
    return url
  }

  return {
    serviceUrl,
    settings,
    app,
    scope,
    uiPath,
    api,
    get,
    environment,
    debug,
    isProd: environment == 'production',
    isDev: environment == 'development'
  }

})